import { ComponentProps } from "react"

type textAreaProps = ComponentProps<'textarea'>

export function TextArea(props: textAreaProps) {
    return (
        <textarea
            className={`py-2 px-3 min-h-20 max-h-40 outline-hidden appearance-none 
                rounded-sm shadow border border-dark_secondary dark:border-light_secondary
                 dark:bg-silver-500 focus:ring-ochre_accent focus:border-ochre_accent`} {...props} />
    )
}